// extracted by mini-css-extract-plugin
export var active = "_ln-2";
export var recordingDot = "_ln-1";
export var recordingIndicator = "_ln-0";